export default __webpack_public_path__ + "static/media/warning--closed-lane-in-triple-lanes--g2.478e5f17.png";